import React from "react";
import Button from "~/app/common/Button";
import useTranslation from "~/app/hooks/useTranslation";
import classes from "./style.module.scss";

export type WizardStep = 1 | 2 | 3;

export type FooterProps = {
  step: WizardStep;
  onNext: () => void;
  onBack: () => void;
  onSubmit: () => void;
  nextDisabled: boolean;
  submitDisabled: boolean;
};

export type FooterComponent = React.FC<FooterProps>;

const Footer: FooterComponent = ({
  step,
  onNext,
  onBack,
  onSubmit,
  nextDisabled,
  submitDisabled,
}) => {
  const { t } = useTranslation("workorder.create");

  if (step === 1) {
    return (
      <div className={classes.footer}>
        <Button
          type="button"
          color="primary"
          block
          className={`${classes.next} ${classes["next--full"]}`}
          disabled={nextDisabled}
          onClick={onNext}
        >
          {t("next")}
        </Button>
      </div>
    );
  }

  if (step === 2) {
    return (
      <div className={classes.footer}>
        <Button
          type="button"
          block
          className={classes.back}
          onClick={onBack}
        >
          {t("back")}
        </Button>
        <Button
          type="button"
          color="primary"
          block
          className={classes.submit}
          disabled={nextDisabled}
          onClick={onNext}
        >
          {t("next")}
        </Button>
      </div>
    );
  }

  return (
    <div className={classes.footer}>
      <Button
        type="button"
        block
        className={classes.back}
        onClick={onBack}
      >
        {t("back")}
      </Button>
      <Button
        type="button"
        color="primary"
        block
        className={classes.submit}
        disabled={submitDisabled}
        onClick={onSubmit}
      >
        {t("submit")}
      </Button>
    </div>
  );
};

export default Footer;
